export default "__VITE_ASSET__e96fe3a4__"